import { useTexts } from 'utils/useTexts';
import LenderInformationForm from '@components/LenderInformation/LenderInformationForm';
import Footer from '@components/shared/Footer/Footer';

const LenderInformation = () => {
  const { t } = useTexts();
  return (
    <>
      <LenderInformationForm />
      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default LenderInformation;
